import { connect } from 'react-redux';
import toast from 'react-hot-toast';
import { Modal } from 'react-daisyui';
import { X } from 'lucide-react';
import { ProfileActions } from 'store/actions';
import AuthorizeForm from './Form';
import { buildPayload } from './helper';

const enhancer = connect(null, { ...ProfileActions });

const AuthorizePersonModal = ({ contacts, createAuthorizedContact, onClose, onAuthorized = null }) => {
  const handleSubmit = async (values) => {
    try {
      await createAuthorizedContact(buildPayload(values));

      toast.success('Person authorized successfully');
      onClose();
      onAuthorized?.();
    } catch (error: any) {
      toast.error(error.errors || 'Failed to authorize this person. Please try again later.');
    }
  };

  return (
    <Modal
      open
      style={{ margin: 0, backgroundColor: 'rgba(15, 23, 42, 0.45)' }}
      className="flex max-h-[calc(100dvh-1.5rem)] w-[92%] max-w-xl flex-col overflow-hidden rounded-2xl p-0 shadow-2xl sm:max-h-[calc(100vh-4rem)]"
    >
      <div className="flex shrink-0 items-start gap-3 px-5 pb-4 pt-5 sm:px-6 sm:pt-6">
        <div className="min-w-0 flex-1">
          <h3 className="text-lg font-bold text-secondary-900">Authorize a person</h3>
          <p className="mt-1 text-sm text-secondary-500">Choose one person we can speak with about your care.</p>
        </div>

        <button
          type="button"
          onClick={onClose}
          aria-label="Close"
          className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-secondary-100 text-secondary-500 transition-colors hover:bg-secondary-200 hover:text-secondary-900"
        >
          <X size={18} strokeWidth={2.5} />
        </button>
      </div>

      <AuthorizeForm contacts={contacts} onCancel={onClose} onSubmit={handleSubmit} />
    </Modal>
  );
};

export default enhancer(AuthorizePersonModal);
